import {FETCH_INS_OFFERS, SET_SELLECTED_OFFER, SET_REVISED_OFFER, UPDATE_REVISED_OFFER, CREATE_INS_CONTRACT, 
        CLEAR_NEW_LIABILITY_POLICY, CREATE_INS_CONTRACT_FAILED} from '../actions/types';

export const insOffersReducer = (state = {offers: {}} , action) => {
    switch(action.type) {
        case FETCH_INS_OFFERS:
            return {...state, offers: {...state['offers'], ...action.payload}} || false;
        case SET_SELLECTED_OFFER:
            return {...state, selectedOffer: action.payload }  || false;
        case SET_REVISED_OFFER:
            return {...state, revisedOffer: action.payload }  || false;
        case CREATE_INS_CONTRACT:
            const revisedOffer = state.revisedOffer || {};
            return {...state, createContractFailed: false, revisedOffer: {...revisedOffer, insuranceId: action.payload}}  || false;
        case CREATE_INS_CONTRACT_FAILED:
            return {...state, createContractFailed: true}  || false;
        case  UPDATE_REVISED_OFFER: {
            const revisedOffer = state.revisedOffer || {};
            return {...state, revisedOffer: {...revisedOffer, ...action.payload}}  || false;
        }
        case CLEAR_NEW_LIABILITY_POLICY:
            return {offers: {}};
            
        default:
            return state;
    }
}